<div id="pinnedUnitArea" class="bulb-block-container-tile"
     (dragover)="onDragOver($event)"
     (drop)="onDropContainer($event)">

  <div *ngIf="filteredPinnedUnits.length < 1">
    <p class="pin-unit-info">
      <ng-container *ngIf="group.permissions?.includes('UPDATE'); else noPinAccess">
        {{ 'pinnedUnits.dragUnitToPin' | transloco }}
      </ng-container>

      <ng-template #noPinAccess>
        {{ 'pinnedUnits.studentInfo' | transloco }}
      </ng-template>
    </p>
  </div>

  <div #pinnedUnit *ngFor="let unit of filteredPinnedUnits; let i = index"
       class="bulb-block-draggable-wrapper"
       (dragstart)="onDragStart($event, pinnedUnit, unit)"
       (dragover)="onDragOver($event)"
       (drop)="onDrop($event, i)">

    <div *ngIf="!(unit.deleteAfterDays && unit.deleteAfterDays > 0)">
      <div class="bulb-block-drop-order-separation"
           (dragenter)="onDragEnterSeparator($event)"
           (dragleave)="onDragLeaveSeparator($event)">
        <div class="drag-handle">
          <div class="drag-handle-line"></div>
        </div>
      </div>

      <article [ngClass]="{ 'bulb-block-collection' : unit.unitType === 'CompositeUnit' || unit.unitType === 'AssignmentCompositeUnit' }"
               class="bulb-block-wrapper bulb-block-wrapper-tile upgraded-blocks">
        <bulb-block [pinnedUnitIds]="pinnedUnitIds" [canUpdate]="group.permissions?.includes('UPDATE')" [groupId]="group.id" [unit]="unit" tile="true"></bulb-block>
      </article>
    </div>
  </div>
</div>
